<template>
    <div class="loading-wrapper d-flex align-items-center justify-content-center" :style="modalStyle">
        <div class="card border-light" style="width: 18rem;">
            <div class="card-body text-center">
                <b-spinner v-if="iconType == ''" :variant=spinnerType label="Spinning" :font-scale="iconSize" />
                <b-icon v-else :icon="iconType" :variant="iconVariant" :font-scale="iconSize" />
                <h5 class="card-title">{{ $t(title) }}</h5>
                <p v-if="text !== ''" class="card-text">
                    {{ $t(text) }}
                </p>
                <slot name="content">
                </slot>   
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
          spinnerType: {
            type: String,
            default: () => "primary",
          },
          iconSize: {
            type: String,
            default: () => "10.5"
          },
          title: {
            type: String,
            default: () => "loading"
          },
          text: {
            type: String,
            default: () => "loading-hierarchy"
          },
          iconType: {
            type: String,
            default: () => "",
          },
          iconVariant: {
            type: String,
            default: () => "",
          },
          modalStyle: {
            type: Object,
            default: () => ({ height: "100vh" }),
          },
        },
        components: {
        },
        data() {
          return {
            
          };
        },
        methods: {
            
        },
      };
</script>